import React, { useEffect, useState } from 'react';
import { DATA } from '../data/urunler-data'; // DATA dışarıdan import ediliyor
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

// MENU_ITEMS: Üst menü öğeleri çeviri anahtarları ile tanımlanıyor.
const MENU_ITEMS = [
  { nameKey: 'headerMenu.home', link: '/' },
  { nameKey: 'headerMenu.about', link: '/hakkimizda' },
  {
    nameKey: 'headerMenu.systems',
    isDropdown: true,
    data: DATA, // DATA içerisindeki veriler dropdown olarak kullanılacak
  },
  { nameKey: 'headerMenu.projects', link: '/projeler' },
  // { nameKey: 'headerMenu.blog', link: '/blog-haberler/sektorel-haberler' },
  { nameKey: 'headerMenu.contact', link: '/iletisim' },
];

const HeaderMenu = ({ toggle, setToggle }) => {
  const [openDropdown, setOpenDropdown] = useState(false);
  const [openSystems, setOpenSystems] = useState({});
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // Link'e tıklandığında menü kapanır ve navigasyon animasyonun tamamlanması için gecikmeli yapılır.
  const handleLinkClick = (link) => {
    setToggle(false);
    setTimeout(() => {
      navigate(link);
    }, 500);
  };



  useEffect(() => {
    if (toggle) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [toggle]);
  return (
    <div className="h-full flex">
      <nav className="text-black">
        <ul className="space-y-4">
          {MENU_ITEMS.map((item, index) => (
            <li key={index}>
              {item.isDropdown ? (
                <>
                  {/* Açılır menü başlığı */}
                  <div
                    className="text-lg md:text-xl font-light flex items-center cursor-pointer"
                    onClick={() => setOpenDropdown(!openDropdown)}
                  >
                    <span>{t(item.nameKey)}</span>
                    <motion.svg
                      className="w-4 h-4 ml-2"
                      animate={{ rotate: openDropdown ? 90 : 0 }}
                      transition={{ duration: 0.3 }}
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M6.293 4.293a1 1 0 011.414 0L13 9.586a1 1 0 010 1.414L7.707 16.293a1 1 0 01-1.414-1.414L10.586 10 6.293 5.707a1 1 0 010-1.414z"
                        clipRule="evenodd"
                      />
                    </motion.svg>
                  </div>
                  <AnimatePresence>
                    {openDropdown && item.data && (
                      <motion.ul
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.5, ease: 'easeInOut' }}
                        className="ml-8 space-y-2 mt-2"
                      >
                        {item.data.map((category, categoryIndex) => (
                          <li key={categoryIndex}>
                            {/* Kategori başlığı; DATA içindeki kategori isimleri nesne olarak tanımlandıysa */}
                            <div
                              className="text-lg md:text-xl font-light flex items-center cursor-pointer"
                              onClick={() =>
                                setOpenSystems((prevState) => ({
                                  ...prevState,
                                  [categoryIndex]: !prevState[categoryIndex],
                                }))
                              }
                            >
                              <span>
                                {category.name && category.name[currentLanguage]
                                  ? category.name[currentLanguage]
                                  : category.name}
                              </span>
                              <motion.svg
                                className="w-4 h-4 ml-2"
                                animate={{
                                  rotate: openSystems[categoryIndex] ? 90 : 0,
                                }}
                                transition={{ duration: 0.3 }}
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M6.293 4.293a1 1 0 011.414 0L13 9.586a1 1 0 010 1.414L7.707 16.293a1 1 0 01-1.414-1.414L10.586 10 6.293 5.707a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </motion.svg>
                            </div>
                            <AnimatePresence>
                              {openSystems[categoryIndex] && category.innerCategory && (
                                <motion.ul
                                  initial={{ height: 0, opacity: 0 }}
                                  animate={{ height: 'auto', opacity: 1 }}
                                  exit={{ height: 0, opacity: 0 }}
                                  transition={{ duration: 0.5, ease: 'easeInOut' }}
                                  className="ml-8 space-y-2 mt-2 overflow-hidden"
                                >
                                  {category.innerCategory.map((innerCategory, systemIndex) => (
                                    <li key={systemIndex}>
                                      <div
                                        onClick={() =>
                                          handleLinkClick(
                                            `/sistemler/${category.link}/${innerCategory.link}`
                                          )
                                        }
                                        className="text-lg md:text-xl font-light cursor-pointer"
                                      >
                                        {innerCategory.name && innerCategory.name[currentLanguage]
                                          ? innerCategory.name[currentLanguage]
                                          : innerCategory.name}
                                      </div>
                                    </li>
                                  ))}
                                </motion.ul>
                              )}
                            </AnimatePresence>
                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </>
              ) : (
                <div
                  onClick={() => handleLinkClick(item.link)}
                  className="text-lg md:text-xl font-light cursor-pointer"
                >
                  {t(item.nameKey)}
                </div>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default HeaderMenu;
